import { MAX_NAME_LENGTH } from '~/composables/useUserValidator'

export const isValidAccountName = (name: string): boolean => {
  return /^[a-zA-Z0-9._%+-]+$/.test(name)
}

export const isValidEmail = (value: string) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
}

export const extractAccountName = (email: string): string => {
  if (!isValidEmail(email)) {
    throw new Error('Invalid email address')
  }

  const atIndex = email.indexOf('@')
  if (atIndex === -1) {
    throw new Error('Invalid email address')
  }
  return email.slice(0, Math.min(atIndex, MAX_NAME_LENGTH * 2))
}
